import { useEffect, useState } from "react";

export type FilterBarMode = "chips" | "classic";

const STORAGE_KEY = "webadmincc-filter-bar-mode";
const EVT = "webadmincc-filter-bar-mode-changed";

/** Read preference. Default = "classic". */
export function getFilterBarMode(): FilterBarMode {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === "classic" || raw === "chips") return raw;
  } catch { /* noop */ }
  return "classic";
}

export function setFilterBarMode(mode: FilterBarMode): void {
  try { localStorage.setItem(STORAGE_KEY, mode); } catch { /* noop */ }
  window.dispatchEvent(new Event(EVT));
}

/** React hook — re-renders consumers when the preference changes. */
export function useFilterBarMode(): [FilterBarMode, (m: FilterBarMode) => void] {
  const [mode, setMode] = useState<FilterBarMode>(getFilterBarMode);

  useEffect(() => {
    function onChange() { setMode(getFilterBarMode()); }
    window.addEventListener(EVT, onChange);
    window.addEventListener("storage", onChange);
    return () => {
      window.removeEventListener(EVT, onChange);
      window.removeEventListener("storage", onChange);
    };
  }, []);

  return [mode, setFilterBarMode];
}
